import { useMutation } from "urql";

import { CreateTradeInsuranceDocument } from "../../../graphql/generated.ts";

export const useCreateTradeInsurance = () =>
  useMutation(CreateTradeInsuranceDocument);
